import MenuPrint from './MenuPrint'
export default MenuPrint
